module.exports = __webpack_public_path__ + "static/media/0020eb30-c98c-4a76-aaa5-c39374f14534.1bf31475.eot";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/1274151/0020eb30-c98c-4a76-aaa5-c39374f14534.eot
// module id = 555
// module chunks = 2